<template>
  <div class="footer">
    <div class="footer-top-row">
      <div class="tex">江阴千游网络科技有限公司</div>
      <div class="tex footer-empty-block"></div>
      <a href="https://beian.miit.gov.cn/#/Integrated/index">
        <div class="tex footer-icp-text">ICP备案号：苏ICP备2022030317号-8</div>
      </a>
    </div>
    <div class="tex">
      健康游戏忠告：抵制不良游戏 拒绝盗版游戏 注意自我保护 防受骗上当
      适度游戏益脑 迷游戏伤身 合理安排时间 享受健康生活
    </div>
    <div class="footer-bottom-row">
      <router-link to="/yinsi" target="_blank">《隐私政策》</router-link>
      <div class="tex footer-mail-text">违规投诉/举报邮箱：xiecheng1@3975.com</div>
      <div class="tex footer-mail-text">违规投诉/举报邮箱：jiankongzu2024@163.com</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DownloadGameFooter',
}
</script>

<style scoped lang="scss">
a {
  color: #f8f3e9;
}

.footer {
  width: 100%;
  height: 1.151042rem;
  background: #231c0e;
  color: #ffffff;
  font-size: 0.083333rem;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  line-height: 0.251042rem;
}

.footer--match-theme {
  background: #000000;
}

.footer-top-row {
  display: flex;
}

.footer-bottom-row {
  display: flex;
  align-items: center;
}

.footer-empty-block {
  margin-left: 0.49rem;
}

.footer-icp-text {
  margin-left: 0.69rem;
}

.footer-mail-text {
  margin-left: 0.29rem;
}
</style>
